import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as motion from "motion/react-client";
import useEmblaCarousel from "embla-carousel-react";
import faqData from "../../data/faqData.json";
import landingPic from "../../assets/pantalla.png";
import logoPic from "../../assets/logo.jpeg";
import principal from "../../assets/principal.jpeg"
import graduados1 from "../../assets/graduados1.jpeg"
import graduados2 from "../../assets/graduados2.jpeg"
import graduados3 from "../../assets/graduados3.jpeg"
import graduados4 from "../../assets/graduados4.jpeg"
import graduados5 from "../../assets/graduados5.jpeg"
import graduados6 from "../../assets/graduados6.jpeg"
import graduados7 from "../../assets/graduados7.jpeg"
import graduados8 from "../../assets/graduados8.jpeg"
import graduados9 from "../../assets/graduados9.jpeg"
import graduados10 from "../../assets/graduados10.jpeg"
import graduados11 from "../../assets/graduados11.jpeg"
import graduados12 from "../../assets/graduados12.jpeg"
import graduados13 from "../../assets/graduados13.jpeg"

const HomePage = () => {
  const navigate = useNavigate();
  const [showAnswers, setShowAnswers] = useState<{ [key: number]: boolean }>({});
  const [emblaRef, emblaApi] = useEmblaCarousel({loop:true})

  const successImages = [
    principal,
    graduados1,
    graduados2,
    graduados3,
    graduados4,
    graduados5,
    graduados6,
    graduados7,
    graduados8,
    graduados9,
    graduados10,
    graduados11,
    graduados12,
    graduados13,
  ];

  useEffect(() => {
    if (!emblaApi) return;
    const autoplay = () => {
      if (emblaApi) emblaApi.scrollNext();
    };
    const interval = setInterval(autoplay, 3000);
    return () => clearInterval(interval);
  }, [emblaApi]);

  return (
  <div className="bg-[#FEFEFE] flex flex-col w-full relative">
    <div className="bg-[#A3C1D1] h-screen w-full flex flex-col">
      <div className="w-full flex flex-col sm:flex-row h-full">
        <div className="flex flex-col w-full sm:w-1/2 items-center justify-center">
          <div className="flex flex-col justify-start w-3/4 sm:w-1/2 gap-3">
            <h1 className="text-[64px] sm:text-[128px] font-playfair hover:text-[#1C1C2E] transition-colors duration-300">Instituto HAS</h1>
            <p className="text-[#363636] text-xl sm:text-2xl hover:text-[#55727D] transition-colors duration-300">Educación autodidacta basada en módulos semanales.</p>
            <button onClick={() => navigate("/StudentLogin")} className="bg-[#1C1C2E] w-full sm:w-1/2 py-3 rounded-md text-white text-xl sm:text-2xl font-playfair hover:bg-[#2D2D51] transition-transform duration-300">Iniciar Sesión</button>
          </div>
        </div>
        <div className="w-full sm:w-1/2 flex items-center justify-center mt-8 sm:mt-0">
          <img src={logoPic} alt="imagen de logo decorativa" className="w-3/4 sm:w-auto rounded-full"/>
        </div>
      </div>
      <div className="bg-[#1C1C2E] h-[10%] flex items-center w-full">
        <h1 className="text-[#A3C1D1] text-xl sm:text-2xl font-playfair hover:text-[#8AAEBF] transition-colors duration-300 w-full text-center sm:hidden">El mejor lugar para aprender.</h1>
        <div className="hidden sm:flex flex-row justify-between w-full px-8 items-center">
          <h1 className="text-[#A3C1D1] text-2xl font-playfair hover:text-[#8AAEBF] transition-colors duration-300">El mejor lugar para aprender.</h1>
          <h1 className="text-[#A3C1D1] text-2xl font-playfair hover:text-[#8AAEBF] transition-colors duration-300">El mejor lugar para aprender.</h1>
          <h1 className="text-[#A3C1D1] text-2xl font-playfair hover:text-[#8AAEBF] transition-colors duration-300">El mejor lugar para aprender.</h1>
          <h1 className="text-[#A3C1D1] text-2xl font-playfair hover:text-[#8AAEBF] transition-colors duration-300">El mejor lugar para aprender.</h1>
        </div>
      </div>
    </div>

    <div className="h-screen flex flex-col w-full relative">
      <div className="w-full h-2/3 flex flex-col sm:flex-row">
        <div className="flex w-full sm:w-1/2 items-center justify-center">
          <div className="w-full flex justify-start">
            <h1 className="font-playfair text-[48px] sm:text-[96px] pl-4 sm:pl-24 hover:text-[#7091A8] transition-colors duration-300">Aprende sobre un nuevo tema cada semana</h1>
          </div>
        </div>
        <div className="w-full sm:w-1/2 flex items-center justify-center mt-8 sm:mt-0">
          <img src={landingPic} alt="imagen decorativa de dashboard" className="w-3/4 sm:w-auto hover:scale-105 transition-transform duration-300"/>
        </div>
      </div>
<div className="w-full flex flex-row h-1/3 overflow-x-auto sm:overflow-x-visible">
  <div className="flex-shrink-0 w-3/4 sm:w-1/4 bg-[#A3C1D1] flex items-center justify-center h-full hover:bg-[#8AAEBF] transition-colors duration-300">
    <div className="flex flex-col items-center justify-center hover:scale-105 transition-transform duration-300">
      <p className="text-[32px] sm:text-5xl font-sourceSans text-white">+ 100</p>
      <p className="text-xl sm:text-4xl font-sourceSans text-white">Estudiantes</p>
    </div>
  </div>
  <div className="flex-shrink-0 w-3/4 sm:w-1/4 bg-[#8AAEBF] flex items-center justify-center h-full hover:bg-[#7091A8] transition-colors duration-300">
    <div className="flex flex-col items-center justify-center hover:scale-105 transition-transform duration-300">
      <p className="text-[32px] sm:text-5xl font-sourceSans text-white">Aprende</p>
      <p className="text-xl sm:text-4xl font-sourceSans text-white">a tu ritmo</p>
    </div>
  </div>
  <div className="flex-shrink-0 w-3/4 sm:w-1/4 bg-[#7091A8] flex items-center justify-center h-full hover:bg-[#55727D] transition-colors duration-300">
    <div className="flex flex-col items-center justify-center hover:scale-105 transition-transform duration-300">
      <p className="text-[32px] sm:text-5xl font-sourceSans text-white">Evalúa</p>
      <p className="text-xl sm:text-4xl font-sourceSans text-white">tu conocimiento</p>
    </div>
  </div>
  <div className="flex-shrink-0 w-3/4 sm:w-1/4 bg-[#55727D] flex items-center justify-center h-full hover:bg-[#3B5155] transition-colors duration-300">
    <div className="flex flex-col items-center justify-center hover:scale-105 transition-transform duration-300">
      <p className="text-[28px] sm:text-5xl font-sourceSans text-white">Información</p>
      <p className="text-xl sm:text-4xl font-sourceSans text-white">siempre a la mano</p>
    </div>
  </div>
</div>

    </div>

    <div className="bg-[#A3C1D1] h-screen flex flex-col items-center w-full relative">
      <div className="w-full sm:w-3/4 md:w-2/3 mt-4 flex flex-col items-center justify-center gap-3">
        <h1 className="text-[48px] sm:text-[96px] font-playfair text-center hover:text-[#1C1C2E] transition-colors duration-300">Historias de éxito en Instituto HAS</h1>
        <div className="bg-[#1C1C2E] p-2 w-full sm:w-[40%] lg:w-[70%] rounded-md shadow-md hover:shadow-xl transition-shadow duration-300">
          <p className="text-lg sm:text-xl text-white font-sourceSans text-center hover:text-[#A3C1D1] transition-colors duration-300">Forma parte de la familia y construye un mejor futuro como nuestros alumnos graduados.</p>
        </div>
        <div className="w-full flex flex-col items-center mt-12">
          <div className="overflow-hidden w-full sm:w-[90%] hover:shadow-2xl transition-shadow duration-500" ref={emblaRef}>
            <div className="flex">
              {successImages.map((src, index) => (
                <div key={index} className="flex-shrink-0 w-full sm:w-1/3 px-2">
                  <img src={src} alt={`Éxito ${index + 1}`} className="w-full h-60 sm:h-96 object-cover rounded-md shadow-lg hover:scale-105 transition-transform duration-500"/>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-[#1C1C2E] w-full pb-12">
      <div className="w-full flex flex-col items-center">
        <h1 className="text-[32px] sm:text-[48px] font-playfair text-white mt-12 mb-16 hover:text-[#A3C1D1] transition-colors duration-300">Conoce nuestros métodos de pago.</h1>
        <div className="w-full flex flex-col sm:flex-row justify-between px-4 sm:px-16 gap-4 sm:gap-0">
          <div className="bg-[#ffffff] w-full sm:w-1/4 flex justify-center rounded-md shadow-md py-8 sm:py-12 hover:shadow-xl transition-shadow duration-300">
            <p className="font-sourceSans text-xl sm:text-2xl hover:text-[#A3C1D1] transition-colors duration-300">Transferencia</p>
          </div>
          <div className="bg-[#ffffff] w-full sm:w-1/4 flex justify-center rounded-md shadow-md py-8 sm:py-12 hover:shadow-xl transition-shadow duration-300">
            <p className="font-sourceSans text-xl sm:text-2xl hover:text-[#A3C1D1] transition-colors duration-300">Pago desde la plataforma</p>
          </div>
          <div className="bg-[#ffffff] w-full sm:w-1/4 flex justify-center rounded-md shadow-md py-8 sm:py-12 hover:shadow-xl transition-shadow duration-300">
            <p className="font-sourceSans text-xl sm:text-2xl hover:text-[#A3C1D1] transition-colors duration-300">Depósito</p>
          </div>
        </div>
      </div>
    </div>

    <div className="w-full px-4 pt-12 sm:pt-24 pb-12 flex flex-col items-center">
      <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="w-full sm:w-[90%] lg:w-[70%] bg-[#A3C1D1] rounded-lg shadow-xl flex flex-col items-center px-4 sm:px-6 md:px-12 py-8 sm:py-12 gap-6 hover:scale-[1.02] transition-transform duration-300">
        <h1 className="font-sourceSans text-2xl sm:text-3xl lg:text-4xl hover:text-[#1C1C2E] transition-colors duration-300">Preguntas frecuentes</h1>
        {faqData.map((faq) => (
          <div key={faq.id} className="bg-[#E3E7EB] w-full rounded-lg shadow-md px-4 py-4 flex flex-col gap-2 hover:bg-[#D1D5D9] transition-colors duration-300">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
              <p className="font-semibold text-base sm:text-lg font-playfair hover:text-[#55727D] transition-colors duration-300">{faq.question}</p>
              <button onClick={() => setShowAnswers((prev) => ({ ...prev, [faq.id]: !prev[faq.id] }))} className="text-sm underline hover:text-[#363636] transition-colors duration-300">{showAnswers[faq.id] ? "Ocultar respuesta" : "Mostrar respuesta"}</button>
            </div>
            {showAnswers[faq.id] && <p className="text-base hover:text-[#1C1C2E] transition-colors duration-300">{faq.answer}</p>}
          </div>
        ))}
      </motion.div>
    </div>
  </div>
  );
};

export default HomePage;
